import { render } from "./PromoCodeWidget.vue?vue&type=template&id=15847164&scoped=true"
import script from "./PromoCodeWidget.vue?vue&type=script&lang=ts"
export * from "./PromoCodeWidget.vue?vue&type=script&lang=ts"

import "./PromoCodeWidget.vue?vue&type=style&index=0&id=15847164&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-15847164"

export default script